import * as React from 'react';

import { trackEvent } from '@/analytics/trackEvent';
import type { FeedItemType } from '@/types';
import { getAppUrl } from '@/utils/getAppUrl';
import { openInNewTab } from '@/utils/openInNewTab';

const PRIVATE_CATEGORIES = ['chats', 'drives', 'notes', 'gmail'];

export const useSourceClick = function (result: FeedItemType) {
  let linkToSource: string;

  if (result.source === 'needlnote') {
    linkToSource = `/preview/needl_notebooks/${result.note_guid}`;
  } else if (result.source === 'needl_notebooks') {
    linkToSource = `/preview/needl_notebooks/${result.deeplink}`;
  } else if (PRIVATE_CATEGORIES.includes(result.category)) {
    linkToSource =
      result.external_access_link || getAppUrl(result.source?.toLowerCase());
  } else {
    linkToSource =
      result.external_access_link ||
      result.link_to_pdf ||
      (Array.isArray(result.link) ? result.link[0] : result.link) ||
      result.embedded_link ||
      getAppUrl(result.source?.toLowerCase());
  }

  const openSourceClickHandler = React.useCallback(
    (e) => {
      if (linkToSource) {
        e.stopPropagation();
        openInNewTab(linkToSource);
        trackEvent('source_opened', {
          source: result.source || '',
          type: PRIVATE_CATEGORIES.includes(result.category)
            ? 'private'
            : 'public',
        });
      }
    },
    [linkToSource, result.category, result.source]
  );

  return { openSourceClickHandler, linkToSource };
};
